import React, { useState } from "react";
import gql from "graphql-tag";
import styled from "styled-components";
import { TypedDocumentNode, useQuery } from "@apollo/client";
import { notificationHeaderYellow } from "../../common/colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faInfo, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { ActionButton } from "../../common/components";

type MainHeaderNotification = {
  title: string;
  content: string;
};

const MAIN_HEADER_NOTIFICATION_QUERY: TypedDocumentNode<{ mainHeaderNotification: MainHeaderNotification }> = gql`
  query MainHeaderNotification {
    mainHeaderNotification {
      title
      content
    }
  }
`;

export function MainHeaderNotificationComponent() {
  const { data } = useQuery(MAIN_HEADER_NOTIFICATION_QUERY);
  const [expanded, setExpanded] = useState(false);

  const [dismissed, setDismissed] = useLocalStorage<boolean>("main-notification-dismissed.muat-read-only", false);

  if (data?.mainHeaderNotification) {
    const notification = data.mainHeaderNotification;
    return (
      <Anchor placement={dismissed ? "left" : "top"} fontSize={dismissed ? "10pt" : "12pt"}>
        <Container>
          <TitleContainer onClick={() => setExpanded(!expanded)}>
            <Title>
              <FontAwesomeIcon icon={faInfo} />
              {notification.title}
            </Title>
            <FontAwesomeIcon icon={expanded ? faWindowClose : faCaretDown} />
          </TitleContainer>
          {expanded && (
            <ContentContainer>
              <Content>{notification.content}</Content>
              <ActionButton
                onClick={() => {
                  setDismissed(true);
                  setExpanded(false);
                }}
              >
                Dismiss
              </ActionButton>
            </ContentContainer>
          )}
        </Container>
      </Anchor>
    );
  } else {
    return null;
  }
}

const Anchor = styled.div<{ placement: "left" | "top"; fontSize: string }>`
  position: absolute;
  display: flex;
  justify-content: center;
  //right: 0;
  //top: 75px;
  top: ${({ placement }) => (placement === "left" ? "75px" : "85px")};
  transition: left 500ms;
  left: ${({ placement }) => (placement === "left" ? "2em" : "40%")};
  font-size: ${({ fontSize }) => fontSize};
`;

const Container = styled.div`
  color: black;
  background: ${notificationHeaderYellow};
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 1px 1px 5px #0004;
  z-index: 1000;
`;

const TitleContainer = styled.div`
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
`;

const Title = styled.div`
  font-weight: bold;
  display: flex;
  gap: 10px;
  cursor: pointer;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
`;

const Content = styled.div`
  white-space: pre-wrap;
`;
